export const globalTokens = {
  fontSizes: {
    XXXS: '12px',
    XXS: '14px',
    XS: '16px',
    SM: '18px',
    MD: '21px',
    LG: '24px',
    XL: '28px',
    XXL: '36px',
  },
  lineHeights: {
    XXXS: '18px',
    XXS: '20.5px',
    XS: '24px',
    SM: '26px',
    MD: '28px',
    LG: '34px',
    XL: '44px',
    XXL: '52px',
  },
  spacing: {
    quark: '4px',
    nano: '8px',
    XXXS: '16px',
    XXS: '24px',
    XS: '32px',
    SM: '40px',
    MD: '48px',
    LG: '56px',
    XL: '64px',
    XXL: '80px',
    XXXL: '120px',
    huge: '160px',
    giant: '200px',
  },
  borderRadius: {
    none: '0px',
    SM: '4px',
    MD: '8px',
    LG: '16px',
    pill: '500px',
    circular: '50%',
  },
  borderWidth: {
    none: '0px',
    hairline: '1px',
    thin: '2px',
    thick: '4px',
    heavy: '8px',
  },
}

export const globalTheme = {
  fontFamily: 'Roboto',
  fontWeights: {
    black: 900,
    bold: 700,
    medium: 500,
    regular: 400,
  },
  colors: {
    primary: {
      pure: '#00AEEF',
      light: '#E3F2FC',
      medium: '#0091C7',
      dark: '#00384D',
    },
    neutral: {
      low: {
        pure: '#000000',
        light: '#949494',
        medium: '#757575',
        dark: '#212121',
      },
      high: {
        pure: '#FFFFFF',
        light: '#E3E3E3',
        medium: '#BFBFBF',
      },
    },
  },
}
